<template>
  <div>
    <div class="checkout-block" v-if="data.basket.length<=0">
      <div class="checkout-tit justify-content-center">
      <span>
          {{ messages.emptyBasket }}
      </span>
      </div>
    </div>
    <div class="container" v-else>
      <form id="order" autocomplete="off" method="post" action="" ref="form">
        <input type="hidden" :name="field.name" :value="field.value" v-for="field in data.hiddenFields"/>
        <div class="row check-page-row">
          <div class="col-lg-12 col-xl-7">
            <div class="checkout-block">
              <div class="checkout-tit">
                <nav>
                  <div class="nav nav-tabs" id="nav-tab" role="tablist">
                    <span v-if="data.authorized">{{ messages.dataFromOrder }}</span>
                    <template v-else>
                      <a
                          href="#nav-signup"
                          class="nav-item nav-item__mobile nav-link"
                          :class="activeTab==='nav-signup'?'active show':''"
                          @click="setTab('nav-signup')"
                      >
                        <span>{{ messages.dataFromOrder }}</span>
                      </a>
                      <a
                          href="#nav-signin"
                          class="nav-item nav-item__mobile nav-link"
                          :class="activeTab==='nav-signin'?'active show':''"
                          @click="setTab('nav-signin')"
                      >
                        <span>{{ messages.dataFromAuth }}</span>
                      </a>
                    </template>
                  </div>
                </nav>
              </div>
              <div class="checkout-body">
                <div class="register-page">
                  <div class="reg-tabs">
                    <div class="tab-content" id="nav-tabContent">
                      <div
                          v-if="!data.authorized"
                          class="tab-pane fade "
                          :class="activeTab==='nav-signin'?' active show':''"
                          id="nav-signin"
                      >
                        <div class="reg-tabs-buttons">
                          <button @click="authTab = 'sms'" type="button" :class="{ 'active': authTab === 'sms' }">Через
                            sms
                          </button>
                          <button @click="authTab = 'password'" type="button"
                                  :class="{ 'active': authTab === 'password' }">Email/пароль
                          </button>
                        </div>
                        <smsAuth v-if="authTab === 'sms'" @auth="authChange()" :params="data.smsAuth"
                                 style="max-width: 400px; margin: 0 auto;"/>
                        <div v-if="authTab === 'password'">
                          <div class="container">
                            <div class="row">
                              <div class="col-md-12">
                                <div class="why-register">
                                  <div class="why-register-tit mb-0">
                                    {{ messages.logInText }}.
                                  </div>
                                </div>
                                <div class="reg-form">
                                  <div class="reg-form-in">
                                    <template v-for="field in data.authFields">
                                      <order_text v-if="field.type==='text'||field.type==='mail'||field.type==='password'"
                                                  :params="field"/>
                                      <order_checkbox v-if="field.type==='checkbox'" :params="field"/>
                                    </template>
                                    <div class="reg-form-inp auth_log_btn">
                                      <button class="def-bt light" id="auth_login_submit" @click.prevent="auth">
                                        {{ messages.logIn }}
                                      </button>
                                      <div class="error-info" v-if="data.authError" v-html="data.authError"></div>
                                    </div>
                                    <div class="forg-pass">
                                      <a href="#" data-toggle="modal" data-target="#forgPass">
                                        {{ messages.forgetPass }}
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                          class="tab-pane fade"
                          :class="activeTab==='nav-signup'||data.authorized?' active show':''"
                          id="nav-signup"
                      >
                        <div class="checkout-form check-log">
                          <div class="row logicBlock">
                            <div :class="'col-sm-'+(i<4?'6':'12')" v-for="(prop, i) in data.props.personal">
                              <order_text :params="prop"/>
                            </div>
                          </div>

                          <div class="checkout-form check-log logicBlock delivery-block">
                            <div class="checkout-form-tit">
                              {{ messages.deliveryBlockTitle }}
                            </div>
                            <div class="check-radio-acc">
                              <div class="accordion">
                                <div class="row">
                                  <div class="col-6" v-for="(prop, i) in data.props.delivery">
                                    <order_text @getError="getError" :params="prop" @input="val => update(val, prop)"/>
                                  </div>
                                </div>
                                <div class="card" v-for="delivery in deliveryList">

                                  <div class="card-header" :id="'headingOne-'+delivery.id">
                                    <DefRadioCheckout
                                        name="DELIVERY_ID"
                                        :value="delivery.id"
                                        :checked="delivery.checked"
                                    >
                                        <span class="chack-radio-tit">
                                             {{ delivery.name }} -
                                             <b v-if="delivery.price > 0" v-html="delivery.priceFormatted"></b>
                                             <span class="grat" v-else v-html="delivery.priceFormatted"></span>
                                        </span>
                                    </DefRadioCheckout>

                                    <!--                                  <label :class="(delivery.checked?'':'collapsed')"-->
                                    <!--                                         data-toggle="collapse"-->
                                    <!--                                         :data-target="'#collapseOne-'+delivery.id"-->
                                    <!--                                         aria-expanded="true"-->
                                    <!--                                         :aria-controls="'collapseOne-'+delivery.id">-->

                                    <!--                                    <input-->
                                    <!--                                        type="radio"-->
                                    <!--                                        name="DELIVERY_ID"-->
                                    <!--                                        @change="update"-->
                                    <!--                                        :value="delivery.id"-->
                                    <!--                                        :checked="delivery.checked"-->

                                    <!--                                    >-->


                                    <!--                                    <span class="check-plus" v-if="delivery.hasPluse"></span>-->
                                    <!--                                  </label>-->
                                  </div>
                                  <div :id="'collapseOne-'+delivery.id"
                                       :class="'collapse '+(delivery.checked?'show':'')"
                                       :aria-labelledby="'headingOne-'+delivery.id">
                                    <div class="row">
                                      <template v-if="!delivery.error">
                                        <div :class="(prop.code === 'APARTMENT' || prop.code === 'HOME')
                                          ? 'col-5 col-md-' + prop.length
                                          : 'col-' + prop.length"
                                             v-for="prop in delivery.subProps">
                                          <order_text
                                              @input="subPropSet(prop)"
                                              @inputPost="subPropSet"
                                              @getError="getError"
                                              :params="prop"
                                              :key="prop.code + '_' + (prop.resetKey || 0)"
                                              v-if="prop.type==='text'||prop.type==='hidden'"
                                          />
                                          <order_select @input="(prop.hasEmmit)?update:''" :params="prop"
                                                        v-if="prop.type==='select'"/>
                                        </div>
                                      </template>
                                      <template v-else>
                                        <div class="col-12">
                                          <span class="error-info">{{ delivery.error }}</span>
                                        </div>
                                      </template>
                                    </div>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="checkout-form check-log">
                            <div class="checkout-form-tit">
                              {{ messages.payBlockTitle }}
                            </div>
                            <div class="check-radio-acc">
                              <div class="accordion">
                                <div class="card" v-for="pay in paySystemList">
                                  <div class="card-header" :id="'headingOne-'+pay.id">
                                    <DefRadioCheckout
                                        name="PAY_SYSTEM_ID"
                                        :value="pay.id"
                                        :checked="pay.checked"
                                    >
                                        <span class="chack-radio-tit">
                                             {{ pay.name }}
                                        </span>
                                    </DefRadioCheckout>

                                    <div class="payParts" v-if="pay.checked && parseInt(pay.id) === 11">
                                      <div>
                                        <span>{{ messages.payParts }}</span>
                                        <select name="ORDER_PROP_77" ref="partsSelect">
                                          <option v-for="opt in partsOptions" :key="opt.value" :value="opt.value">
                                            {{ opt.label }}
                                          </option>
                                        </select>
                                      </div>
                                    </div>

                                    <!--                                  <label  class="collapsed"-->
                                    <!--                                        data-toggle="collapse"-->
                                    <!--                                        :data-target="'#collapseOne-'+pay.id"-->
                                    <!--                                        aria-expanded="true"-->
                                    <!--                                        :aria-controls="'collapseOne-'+pay.id">-->
                                    <!--                                    <span class="chack-radio-tit">-->
                                    <!--                                      {{pay.name}}-->
                                    <!--                                    </span>-->
                                    <!--                                    <input type="radio" name="PAY_SYSTEM_ID" :value="pay.id"  @change="update" :checked="pay.checked">-->
                                    <!--                                    <span class="check-visual"></span>-->
                                    <!--                                  </label>-->
                                  </div>
                                  <div :id="'collapseOne-'+pay.id"
                                       class="collapse"
                                       :aria-labelledby="'headingOne-'+pay.id"
                                  ></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-12 col-xl-5">
            <div class="checkout-block check-cart">
              <div class="checkout-tit">
              <span>
                  {{ messages.basketTitle }}
              </span>
              </div>
              <div class="checkout-body order-basket">
                <div class="condition-text" v-for="text in data.checkoutTexts" :style="'color:' + text.color"
                     v-html="text.text"></div>
                <div class="card-checkout-in">
                  <div class="one-card-check" v-for="item in data.basket" :class="!item.canBuy ? 'error-info' : ''">
                    <div class="one-card-check-in">
                      <div class="one-card-check-left">
                        <div class="one-card-check-discount-price" v-if="item.price<item.bacePrice">
                          {{ item.discountProsent }}
                        </div>
                        <div class="one-card-check-thumb">
                          <a :href="item.link">
                            <img :src="item.picture" :alt="item.name" :title="item.name">
                          </a>
                        </div>

                      </div>
                      <div class="one-card-check-right">
                        <div class="one-card-check-tit">
                          <a :href="item.link">{{ item.name }}</a>
                        </div>
                        <!--                      <div class="one-card-check-atr">-->
                        <!--                        {{messages.art}}: {{item.article}}-->
                        <!--                      </div>-->
                        <div class="one-card-check-opt">
                          <ul>
                            <li v-if="item.size">
                              <span class="op-name">{{ messages.size }}:</span>
                              <div class="sizes">
                                <span class="size">{{ item.size }}</span>
                                <span class="size" v-if="item.sizeUa">{{ item.sizeUa }}</span>
                              </div>
                            </li>
                            <li class="check-price">
                              <div class="checkout-price">
                                <div class="checkout-price__title">
                                  <span>{{ messages.price }}:</span>
                                </div>
                                <div class="checkout-price__value">
                                  <div>
                                    <b>
                                      <span>{{ item.priceFormated }}</span>
                                    </b>
                                  </div>
                                  <div v-if="item.price<item.bacePrice">
                                    <b>
                                      <span class="old-price">{{ item.bacePriceFormated }}</span>
                                    </b>
                                  </div>
                                </div>

                              </div>
                              <!--                            <span class="op-val">-->
                              <!--                              <b v-if="item.price<item.bacePrice">-->
                              <!--                                <span>-->
                              <!--                                  {{ item.priceFormated }}-->
                              <!--                                </span>-->
                              <!--                                <span class="old-price">-->
                              <!--                                  {{ item.bacePriceFormated }}-->
                              <!--                                </span>-->
                              <!--                              </b>-->
                              <!--                              <b v-else>-->
                              <!--                                {{ item.priceFormated }}-->
                              <!--                              </b>-->
                              <!--                            </span>-->
                            </li>
                          </ul>
                        </div>
                        <div class="one-card-check-numb" v-if="!item.isGift">
                          <div class="num-in">
                            <span class="minus noJQEvent" :class="{'disable-click':item.quantity<=1}"
                                  @click.prevent="setBasketItem(item.id,--item.quantity)"></span>
                            <input type="text"
                                   @input="setBasketItem(item.id)"
                                   class="in-num"
                                   :value="item.quantity"
                                   oninput="this.value = this.value.replace(/[^0-9.]/g, ''); this.value = this.value.replace(/(\..*)\./g, '$1');"
                            >
                            <span class="plus noJQEvent"
                                  :class="{'disable-click':item.quantity>=item.availableQuantity}"
                                  @click.prevent="setBasketItem(item.id,++item.quantity)"></span>
                          </div>
                        </div>
                      </div>
                      <div class="del" @click.prevent="delBasketItem(item.id)"></div>
                    </div>
                    <div class="one-card-check-tit not-available-item" v-if="!item.canBuy">
                      {{ messages.notAvailableItem }}
                    </div>
                  </div>
                  <div class="chechout-total">
                    <div class="sub-total-list">
                      <ul>
                        <li>
                          <span class="sub-name">{{ messages.totalPrice }}:</span>
                          <span class="sub-val">{{ data.total.productPrice }}</span>
                        </li>
                        <li>
                          <span class="sub-name">{{ messages.discountSumm }}:</span>
                          <span class="sub-val total-discount-price">{{ data.total.discountPrice }}</span>
                        </li>
                        <li>
                          <span class="sub-name"><b>{{ messages.summ }}:</b></span>
                          <span class="sub-val"><b>{{ data.total.summFormated }}</b></span>
                        </li>
                        <li>
                          <span class="sub-name">{{ messages.deliveryPrice }}:</span>
                          <span class="sub-val">{{ data.total.deliveryPrice }}</span>
                        </li>
                        <li v-for="pay in paySystemList">
                        <span class="sub-val-ps-msg" v-if="pay.checked && pay.price">
                          <b>{{ parseInt(pay.id) === 11 ? installmentText : pay?.price?.psPriceMessage }}</b>
                        </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="have-promo">
                    <div class="one-card-check-other">
                      <div class="one-card-check-other-tit collapsed"
                           data-toggle="collapse"
                           data-target="#coupon-box"
                           aria-expanded="true"
                           aria-controls="coupon-box">
                      <span>
                          {{ messages.couponBlockTitle }}
                      </span>
                        <i></i>
                      </div>
                      <div class="one-card-check-other-descr collapse" id="coupon-box">
                        <div class="promo-check-form" v-if="!data.coupons.length">
                          <div class="promo-check-inp">
                            <input type="text" name="coupon" :placeholder="messages.couponPlaceholder" value="">
                          </div>
                          <div class="promo-check-bt">
                            <button class="def-bt light" @click.prevent="update('addCoupon');update('update');">
                              {{ messages.couponBtn }}
                            </button>
                          </div>
                        </div>
                        <div class="enter-promo-result" style="color: #FF0000" v-if="data.enterCouponText">
                          {{ data.enterCouponText }}
                        </div>
                        <div class="promo-check-form" v-for="coupon in data.coupons">
                          <div class="promo-check-inp">
                            <input type="text" :value="coupon.value" disabled>
                          </div>
                          <div class="promo-check-bt">
                            <button class="def-bt done" @click.prevent="delCoupon(coupon.value)"></button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="one-card-check-other">
                      <div class="one-card-check-other-tit collapsed"
                           data-toggle="collapse"
                           data-target="#ORDER_DESCRIPTION-box"
                           aria-expanded="false"
                           aria-controls="ORDER_DESCRIPTION-box">
                      <span>
                          {{ messages.commentBlockTitle }}:
                      </span>
                        <i></i>
                      </div>
                      <div class="one-card-check-other-descr collapse" id="ORDER_DESCRIPTION-box">
                        <br>
                        <textarea name="ORDER_DESCRIPTION" id="ORDER_DESCRIPTION">{{data.ORDER_DESCRIPTION}}</textarea>
                        <br>
                      </div>
                    </div>
                    <div class="have-promo">
                      <order_checkbox :params="data.dopInputs.dontColl"/>
                    </div>
                    <div class="check-order"></div>
                    <order_checkbox :params="data.dopInputs.checkRules"/>
                    <div class="check-order">
                      <!--                    <order_checkbox :params="data.dopInputs.checkRulesPersonalData"/>-->

                      <p style="color: red" id="errorMessage" v-if="data.errors" v-html="data.errors"></p>
                      <div class="check-bt-order" v-if="data.canOrder">
                        <button :class="disabledOrderButton ? 'disable' : ''" class="def-bt" id="check-but"
                                @click.prevent="createOrder()">{{ messages.orderBtn }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="checkout-block rem">
              <div class="checkout-tit">
              <span>
                  {{ messages.hasTrable }}
              </span>
              </div>
              <div class="rem-serv">
                <div class="one-rem">
                  <div class="one-rem-tit" v-html="messages.otdelTurboty"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="modal fade mid-modal" id="modalResponseStatus" tabindex="-1" role="dialog"
         aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
          <div class="modal-res modal-res--text">

          </div>
        </div>
      </div>
    </div>
    <div class="popup" v-if="data.phoneConfirm">
      <div class="bx-blue" @click.prevent="data.phoneConfirm=false;"></div>
      <div class="content">
        <div class="close" @click.prevent="data.phoneConfirm=false;"></div>
        <confirm-phone @confirmedUser="createOrder" :params="data.phoneConfirm" v-if="data.phoneConfirm"/>
      </div>
    </div>
  </div>
</template>

<script>
import {mapMutations} from 'vuex';
import smsAuth from '../personal/smsAuth.vue';
import DefRadioCheckout from "../Def/DefRadioCheckout/DefRadioCheckout";
import Order_text from "./input/order_text.vue";
import Order_checkbox from "./input/order_checkbox.vue";
import Order_select from "./input/order_select.vue";
import ConfirmPhone from "./confirmPhone.vue"; // Путь к вашему компоненту SmsAuthComponent.vue
export default {
  name: "checkoutBlock",
  selector: '.checkoutBlock',
  props: ['params'],
  data() {
    return {
      messages: this.params.messages,
      data: this.params.data,
      loading: false,
      loadingID: false,
      loadingData: false,
      activeTab: 'nav-signup',
      timeOutIds: {},
      strError: true,
      cityError: true,
      authTab: 'sms',
      disabledOrderButton: false,
      selectedParts: 3
    };
  },
  components: {
    ConfirmPhone,
    Order_select,
    Order_checkbox,
    Order_text,
    DefRadioCheckout,
    smsAuth
  },
  computed: {
    //  Removing ApplePay if device not supported it
    paySystemList: function () {
      let list = Object.values(this.data.paySystems).filter(paySystem => {
        return !(paySystem.action === 'liqpay_apple' && !(window.ApplePaySession && ApplePaySession.canMakePayments()));
      });

      if (!list.some(ps => ps.checked === true) && list.length > 0) {
        list[0].checked = true;
      }

      return list;
    },
    deliveryList: function () {
      let list = Object.values(this.data.deliverySystems);
      let cityProp = this.data.props.delivery.find(item => item.code === 'CITY');

      if (cityProp && !cityProp.isKyiv) {
        list = list.filter(delivery => parseInt(delivery.id) !== 3);
      }

      if (!list.some(ps => ps.checked === true) && list.length > 0) {
        list[0].checked = true;
      }

      return list;
    },
    partsOptions() {
      return [3, 4, 5, 6].map(parts => ({
        value: parts,
        label: parts + ' × ' + this.formatMoney(this.data.total.summ / parts)
      }));
    },

    installmentText() {
      const n = this.selectedParts;
      const monthly = this.formatMoney(this.data.total.summ / n);
      const lang = App.i18nCurrentLang();
      const word = this.decline(n, lang === 'ua'
          ? ['платіж', 'платежі', 'платежів']
          : ['платёж', 'платежа', 'платежей']
      );
      return n + ' ' + word + ' по ' + monthly + ' грн';
    }
  },
  methods: {
    ...mapMutations({
      loaderStart: 'global/loaderStart',
      loaderStop: 'global/loaderStop',
      loaderLog: 'global/loaderLog',
    }),
    setV(prop, t) {
      console.log(prop, t);
    },
    getError(obj) {
      switch (obj.propCode) {
        case 'STREET_NAME':
          this.strError = obj.strErr;
          break;
        case 'CITY':
          this.cityError = obj.cityErr;
          break;

      }
    },
    setTab(tab) {
      this.activeTab = tab;
    },
    setBasketItem(id, quantity) {
      if (quantity === undefined) {
        quantity = event.target.value;
      }

      if (this.timeOutIds.setBasketItem !== undefined) {
        clearTimeout(this.timeOutIds.setBasketItem);
      }

      this.timeOutIds.setBasketItem = setTimeout(() => {
        this.sendData("setBasketItem", undefined, {id: id, quantity: quantity});
        clearTimeout(this.timeOutIds.setBasketItem);
        this.timeOutIds.setBasketItem = undefined;
      }, 1000);

    },
    delCoupon(id) {
      this.sendData("delCoupon", undefined, {id: id});
    },
    createOrder() {
      this.data.phoneConfirm = false;
      if (!this.disabledOrderButton) {
        this.disabledOrderButton = true
        this.sendData("createOrder", (response) => {
          // TOUS-1056: сервер прерывает создание заказа (например, недостаточно товара на
          // складе) и кладёт сообщения в checkout_res — раньше это никак не обрабатывалось.
          const checkoutErrors = response.data.checkout_res && response.data.checkout_res[0];
          if (Array.isArray(checkoutErrors) && checkoutErrors.length) {
            document.getElementById('modalCheckoutErrorMessage').innerText = checkoutErrors.join('\n');
            $('#modalCheckoutError').modal('show');
            this.disabledOrderButton = false;
            return;
          }
          if (response.data.checkout.data.orderConfirmLink) {
            if (response.data.checkout.data.orderId) {
              let date = new Date();
              date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
              let expires = "; expires=" + date.toUTCString();
              document.cookie = "ORDER_ID=" + response.data.checkout.data.orderId + expires + "; path=/";
              localStorage.setItem("ORDER_ID", response.data.checkout.data.orderId);
            } else {
              this.$nextTick(() => {
                this.$nextTick(() => {
                  this.scrollToFirstError();
                });
              });
            }
            setTimeout(() => {
              location.href = response.data.checkout.data.orderConfirmLink;
            }, 500);
          } else if (!response.data.checkout.data.canCreateOrder) {
            $('#modalCannotCreateOrder').modal('show');
            this.disabledOrderButton = false
          } else {
            this.$nextTick(() => {
              this.$nextTick(() => {
                this.scrollToFirstError();
              });
            });
            this.disabledOrderButton = false
          }
        });
      }
    },
    scrollToFirstError() {
      if (this.$store.state.global.screenWidth < 1200) {
        const firstError = document.querySelector('.checkout-body .error-info');
        if (firstError) {
          firstError.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      }
    },
    delBasketItem(id) {
      this.sendData("delBasketItem", undefined, {id: id});
    },
    update(type, prop) {
      if (prop && prop.code === 'CITY') {
        if (this.deliveryList) {
          this.deliveryList.forEach(delivery => {
            if (delivery.subProps) {
              delivery.subProps.forEach(p => {
                if (p.code === 'WAREHOUSE_NP' || p.code === 'POSTOMAT_NP') {
                  p.value = '';
                  p.resetKey = (p.resetKey || 0) + 1;
                }
              });
            }
          });
        }
      }

      this.$nextTick(() => {
        this.sendData(type);
      });
    },
    authChange() {
      this.sendData("", (response) => {
        console.log('smsAuth');
      });
    },
    auth() {
      this.sendData("auth", (response) => {
        if (response.data.checkout.data.authorized) {
          window.location.hash = '#nav-signup';
          history.replaceState(undefined, undefined, "#nav-signup")
        }
      });
    },
    subPropSet(prop) {
      if (prop.hasEmmit === true) {
        if (this.timeOutIds.subPropSet !== undefined) {
          clearTimeout(this.timeOutIds.subPropSet);
        }
        this.timeOutIds.subPropSet = setTimeout(() => {
          this.sendData("update");
          clearTimeout(this.timeOutIds.subPropSet);
          this.timeOutIds.subPropSet = undefined;
        }, 100);
      }
    },
    sendData(type, collback, dopParams) {
      if (type === undefined) {
        type = "update";
      }
      let data = new FormData(this.$refs.form);
      data.append("action", type);
      if (typeof (type) === "object") {
        if (!!type.type) {
          data.append("action_type", type.type || "");
        }
        if (!!type.target && !!type.target.name) {
          data.append("action_target", type.target.name || "");
        }
      }
      data.append("streetErr", this.strError);
      data.append("cityErr", this.cityError);
      if (dopParams !== undefined) {
        for (let key in dopParams) {
          data.append(key, dopParams[key]);
        }
      }
      if (this.loading === false) {
        this.axiosWrap(data, collback);
      } else {
        this.loadingData = {
          data: data,
          collback: collback
        };
        this.loadingID = window.setTimeout(this.resendFunc, 200);
      }
    },
    resendFunc() {
      if (this.loading) {
        window.clearTimeout(this.loadingID);
        this.loadingID = setTimeout(this.resendFunc, 400);
      } else if (this.loadingData) {
        this.axiosWrap(this.loadingData.data, this.loadingData.collback);
      }
    },
    axiosWrap(data, collback) {
      this.loading = true;
      this.loaderStart();
      axios.post("", data).then((response) => {
        this.loading = false;
        /**
         * is set in component order_text.vue ( now,- only for TOP NP cities list )
         * @todo improve if necessary
         */
        this.loaderStop();
        if (collback !== undefined) {
          collback(response);
        }
        $('body').append(response.data.checkout.data.webTracking);
        if (!!response.data.checkout.gtmEcommerce) {
          BX.Aniart.Ecommerce.init().pushEvent(response.data.checkout.gtmEcommerce);
        }

        this.data = response.data.checkout.data;
        //this.$set(this,'data',  response.data.checkout.data);
      }).finally(() => {
        this.loaderStop();
      });
    },
    logger(type) {
      console.log(type)
    },
    checkApplePaySupport() {
      return window.ApplePaySession && ApplePaySession.canMakePayments();
    },
    formatMoney(value) {
      const fixed = value.toFixed(2);
      const clean = fixed.endsWith('.00') ? fixed.slice(0, -3) : fixed;
      return clean.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    decline(n, forms) {
      const abs = Math.abs(n) % 100;
      const last = abs % 10;
      if (abs >= 11 && abs <= 19) return forms[2];
      if (last === 1) return forms[0];
      if (last >= 2 && last <= 4) return forms[1];
      return forms[2];
    }
  },
  mounted() {
    if (window.location.hash !== '') {
      this.activeTab = window.location.hash.replace('#', '');
    }
    const defRadioCheckout = document.querySelectorAll('.def-radio-checkout__input');

    defRadioCheckout.forEach((value, key) => {
      value.addEventListener('change', this.update)
    })

    //  clear URL param
    Object.values(this.data.paySystems).map(function (item) {
      let url = new URL(window.location.href),
          param = 'PS';
      if (url.searchParams.has(param)) {
        url.searchParams.delete(param);
        window.history.replaceState({}, document.title, url);
      }
    })

    $(this.$refs.partsSelect).on('change', (e) => {
      this.selectedParts = Number(e.target.value);
    });
  },
  beforeDestroy() {
    $(this.$refs.partsSelect).off('change');
  },
  beforeUnmount() {
    const defRadioCheckout = document.querySelectorAll('.def-radio-checkout__input');
    defRadioCheckout.forEach((value, key) => {
      value.removeEventListener('change', this.update)
    })
  },
  updated() {
    /*
      [TOUS-729] якщо змінюється кількість методів доставки, то event, який заданий в mounted, злітає
      із-за цього зробив переініціалізацію
    */
    const defRadioCheckout = document.querySelectorAll('.def-radio-checkout__input');

    defRadioCheckout.forEach((value, key) => {
      value.removeEventListener('change', this.update)
    })

    defRadioCheckout.forEach((value, key) => {
      value.addEventListener('change', this.update)
    })

    const select = this.$refs.partsSelect;
    if (select && !$(select).hasClass('styler')) {
      $(select).styler();
      $(select).on('change', (e) => {
        this.selectedParts = Number(e.target.value);
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.logicBlock {
  margin-bottom: 40px;
}

.not-available-item {
  color: #f00;
}

.popup {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;

  .bx-blue {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(3px);
    /*backdrop-filter: invert(80%);*/
    /*backdrop-filter: sepia(30%);*/
  }

  .content {
    position: relative;
    width: 90%;
    margin: auto;
    padding: 20px;
    background: #fff;
    min-height: 20vh;
    max-width: 460px;
    overflow-y: auto;
    top: 10vh;
    box-sizing: border-box;
    max-height: 80vh;
    border: solid 1px #aaa;
    border-radius: 10px;
    text-align: center;

    .close {
      margin-top: -15px;
    }
  }
}

.disable-click {
  pointer-events: none;
}

.reg-tabs-buttons {
  display: flex;
  justify-content: center;

  button {
    background-color: transparent;
    border: 1px solid #c5c4be;
    height: 40px;
    cursor: pointer;
    transition: .2s linear color, .2s linear background-color, .2s linear border-color;

    &.active {
      background-color: #f0c7c2;
      color: #fff;
      border-color: #f0c7c2;
    }
  }

  button:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  button:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
}

.one-card-check-opt {
  .sizes {
    display: flex;
    flex-direction: column;
    float: right;

    .size {
      width: 100%;
      margin-bottom: 0;
      margin-top: -5px;
      text-align: end;
    }
  }
}

.payParts {
  margin-left: 30px;

  span {
    margin-right: 5px;
  }
}

.sub-total-list .total-discount-price {
  font-weight: bold;
}

.delivery-block {
  .card {
    .row {
      margin-bottom: 10px;
    }
  }
}

@media (max-width: 992px) {
  .payParts span {
    font-size: 12px;
  }
}
</style>

<!--
  TOUS-1056: #modalCheckoutErrorMessage рендерится PHP-partial'ом
  (include/{ua,ru}/checkout_error.php) вне шаблона этого компонента,
  поэтому scoped-стиль выше на него не подействует — нужен отдельный
  глобальный блок.
-->
<style lang="scss">
#modalCheckoutErrorMessage {
  text-align: center;
}
</style>
